module.exports = __webpack_public_path__ + "img/bank-building (2) (2).3bbc0365.svg";